export const appSettingsAppGroupIdMessagePrioritizationRulesData =
  "/app_settings/:app_group_id/message_prioritization/rules_data";
